import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify);

const counterBlue = "#273582";
// const contrastBlue = "#107da6";

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: counterBlue,
        secondary: colors.grey,
        accent: colors.orange.lighten2,
      },
      dark: {
        primary: colors.orange.darken2,
      },
    },
  },
});
